import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class VersionService {

  constructor(private http: HttpClient) { }

  public async checkForUpdate(code: string): Promise<void> {
    const localStorageKey = `${code.toLowerCase()}_version_check`;
    const storedVersion = localStorage.getItem(localStorageKey);
    let refresh = storedVersion == null;
    const onlineVersion = await this.get(`https://admin.ftapp.co.za/version/get/${code.toLowerCase()}`);
    if (onlineVersion.version != storedVersion) {
      localStorage.setItem(localStorageKey, onlineVersion.version);
      refresh = true;
    }
    if (refresh) {
      window.location.reload();
    }
  }

  private async get(url: string): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http.get(url)
        .pipe()
        .toPromise()
        .then(res => resolve(res))
        .catch(err => reject(err));
    });
  }
}
